import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { waLink } from "@/data/site";

const links = [
  { label: "Inicio", href: "#inicio" },
  { label: "Beneficios", href: "#beneficios" },
  { label: "Dispositivos", href: "#dispositivos" },
  { label: "Planes", href: "#planes" },
  { label: "Opiniones", href: "#testimonios" },
  { label: "Preguntas", href: "#faq" },
  { label: "Contacto", href: "#contacto" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "glass" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-6 lg:px-12 h-[72px] flex items-center justify-between">
        <a href="#inicio" data-testid="logo" className="flex items-center gap-2.5 group">
          <img
            src="/logo-full.png"
            alt="BrothersPlus TV"
            className="h-12 lg:h-14 w-auto transition-transform duration-200 group-hover:scale-[1.03]"
          />
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-[#A3A3A3] hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href={waLink("Hola, quiero información sobre BrothersPlus TV.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-cta"
          className="hidden lg:inline-flex items-center rounded-full bg-bp-primary px-5 py-2.5 text-sm font-semibold text-white transition-all duration-200 hover:bg-bp-primaryHover active:scale-95 hover:shadow-[0_0_20px_rgba(46,125,255,0.5)]"
        >
          Empezar ahora
        </a>

        <button
          data-testid="menu-toggle"
          className="lg:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menú"
        >
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden glass border-t border-white/5 px-6 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-[#A3A3A3] hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
